import React from 'react';

const BasemapPlaceholder = () => {
  return (
    <>
      <ul className="generic-list basemap-selection__items">
        {Array.from({ length: 3 }, (_, i) => (
          <li
            key={` basemap-selection__item${i}`}
            className="basemap-selection__img-placeholder shimmer"
          />
        ))}
      </ul>
      <div
        className="shimmer"
        style={{
          width: '100%',
          height: '11.6px',
          margin: 'var(--size-s)',
          borderRadius: '10px',
        }}
      />
    </>
  );
};

export default BasemapPlaceholder;
